import { Link } from 'react-router';
import './Call.css';
import { JEFF } from '../config/jeff.ts';
import { useDocumentTitle } from '../lib/hooks.ts';

export function NotFound() {
  useDocumentTitle(`Not found — ${JEFF.appName}`);

  return (
    <main className="callpage" id="main">
      <div className="callpage__empty panel">
        <h1 className="callpage__empty-title">Nothing here</h1>
        <p className="callpage__empty-body">
          Jeff has reviewed this page and declined to comment.
        </p>
        <Link className="btn btn--primary" to="/">
          Back to the pen
        </Link>
      </div>
    </main>
  );
}
